import React from 'react';

interface ChatMessageReadIconProps {
  size?: number;
  className?: string;
}

export const ChatMessageReadIcon: React.FC<ChatMessageReadIconProps> = ({
  size = 12,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M5.801 6.87878L6.507 7.58478L10.74 3.35178L11.447 4.05878L6.507 8.99878L3.325 5.81678L4.032 5.10978L5.0945 6.17228L5.801 6.87828V6.87878ZM5.802 5.46478L8.278 2.98828L8.983 3.69328L6.507 6.16978L5.802 5.46478ZM4.3885 8.29228L3.682 8.99878L0.5 5.81678L1.207 5.10978L1.9135 5.81628L1.913 5.81678L4.3885 8.29228Z"
      fill="currentColor"
    />
  </svg>
);

export default ChatMessageReadIcon;
